var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid manual-assign-container" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "manual-assign" },
          [
            !_vm.$isOrderFullscreen
              ? _c(
                  "el-row",
                  { attrs: { type: "flex" } },
                  [
                    _c(
                      "el-col",
                      {
                        staticClass: "section-container plan-header-container",
                        style: _vm.planHeaderStyle,
                      },
                      [
                        _c("plan-header", {
                          attrs: { type: "manual" },
                          on: { onManualAssignTruck: _vm.handleManualAssign },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-row",
              { style: _vm.planBodyStyle, attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 24 } },
                  [
                    _c(
                      "el-row",
                      {
                        staticClass: "h-100",
                        staticStyle: { "flex-flow": "column wrap" },
                        attrs: { type: "flex" },
                      },
                      [
                        _c(
                          "el-col",
                          {
                            staticClass:
                              "section-container d-none d-md-inline-block pt-0",
                            attrs: { span: 24 },
                          },
                          [
                            _c(
                              "el-row",
                              {
                                staticClass: "h-100",
                                staticStyle: { "flex-flow": "column wrap" },
                                attrs: { type: "flex" },
                              },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-row",
                                      { attrs: { type: "flex", gutter: 4 } },
                                      [
                                        _c(
                                          "el-col",
                                          {
                                            attrs: {
                                              xs: 24,
                                              sm: 24,
                                              md: 24,
                                              lg: 12,
                                            },
                                          },
                                          [_c("order-date-range")],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          {
                                            attrs: {
                                              xs: 24,
                                              sm: 24,
                                              md: 24,
                                              lg: 12,
                                            },
                                          },
                                          [_c("order-filter")],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("order-filter-tag", {
                                      attrs: { type: "manual" },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c("order-table", {
                                      attrs: { tableHeight: "450px" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("hr"),
                        _c(
                          "el-col",
                          {
                            staticClass: "section-container",
                            staticStyle: { "flex-grow": "1", padding: "8px" },
                            attrs: { span: 24 },
                          },
                          [
                            _c("h3", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(_vm.$t("jobOrder.status.assigned"))
                              ),
                            ]),
                            _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.isManualAssignLoading,
                                    expression: "isManualAssignLoading",
                                  },
                                ],
                                staticClass: "mt-3 mb-3",
                                attrs: {
                                  size: "mini",
                                  border: "",
                                  data: _vm.orderData,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    fixed: "",
                                    type: "index",
                                    width: "50",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "planning.columns.containerNumber"
                                    ),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.additionalData
                                                    .containerNumber
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1679182462
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "planning.columns.sealNumber"
                                    ),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.additionalData
                                                    .sealNumber
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3326640898
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t(
                                      "planning.columns.shipmentReference"
                                    ),
                                    prop: "shipmentReference",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t("planning.columns.planId"),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.planId) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1255078947
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t("planning.columns.weight"),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.helper.printThousandDecimal(
                                                    scope.row.capacity
                                                      .capacity1 || 0
                                                  )
                                                ) +
                                                " KG "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4035244435
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: _vm.$t("planning.columns.volume"),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.helper.printThousandDecimal(
                                                    scope.row.capacity
                                                      .capacity2 || 0
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t("planning.tooltip.cbm")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    119589060
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: { width: "67" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "mt-1 mb-1",
                                                attrs: {
                                                  type: "danger",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteOrder(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "trash-alt",
                                                    "aria-hidden": "true",
                                                    size: "lg",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1921533754
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }